import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import { reducers as providerReferralReducers } from '@td/provider_referral';
import { reducers as benefits } from 'medication_service_ui/dist/benefits';
import { reducers as settings } from 'medication_service_ui/dist/settings';

import { PayerSelectorReducer as eligibility, NotificationReducer as notifications } from 'medication_service_ui';
import { emrReducer as emr } from '@td/practice_management_js';
import rteTestReducers from '../RteTestComponent/reducers';
import rteEditPayerReducer from '../EditPayer/reducers';
import { reducer as providerIncentiveCost } from '../provider-incentive/provider-incentive-cost/reducers';
import providerSurgeIncentive from '../provider-incentive/provider-surge-incentive/reducers';
import { egrReducer, egrGroups, egrImport } from '../external_group_relations/reducers';
import { mcorReducer } from '../multi_contract_org_relations/reducers';
import { emrManagerReducer } from '../GrantRevokeEmrManagerRole/redux/emr-manager-reducer';

export const rootReducer = combineReducers({
  rteTest: rteTestReducers,
  form: formReducer,
  providerReferral: providerReferralReducers,
  benefits,
  settings,
  eligibility,
  notifications,
  providerIncentiveCost,
  providerSurgeIncentive,
  egrReducer,
  egrGroups,
  egrImport,
  mcorReducer,
  rteEditPayer: rteEditPayerReducer,
  emr,
  emrManagerReducer
});

export default rootReducer;
